<ng-container [formGroup]="hourForm">
    <app-dropdown [items]="hours" [placeholder]="placeholder" formControlName="from" (touched)="onTouched()" />
</ng-container>
